import { PlacedRoom } from './placement';

function dist2(a: PlacedRoom, b: PlacedRoom): number {
  const dx = a.center.x - b.center.x;
  const dy = a.center.y - b.center.y;
  return dx * dx + dy * dy;
}

/**
 * Minimum spanning tree (Prim) over room centers. Returns the connected pairs
 * as index tuples — a tree, so exactly one path between any two rooms (no loops,
 * per the design decision).
 */
export function buildMST(rooms: PlacedRoom[]): [number, number][] {
  const n = rooms.length;
  if (n < 2) {
    return [];
  }
  const inTree = new Array<boolean>(n).fill(false);
  const bestDist = new Array<number>(n).fill(Infinity);
  const bestFrom = new Array<number>(n).fill(-1);
  const pairs: [number, number][] = [];

  inTree[0] = true;
  for (let j = 1; j < n; j++) {
    bestDist[j] = dist2(rooms[0], rooms[j]);
    bestFrom[j] = 0;
  }

  for (let added = 1; added < n; added++) {
    let next = -1;
    let nextDist = Infinity;
    for (let j = 0; j < n; j++) {
      if (!inTree[j] && bestDist[j] < nextDist) {
        nextDist = bestDist[j];
        next = j;
      }
    }
    if (next === -1) {
      break;
    }
    inTree[next] = true;
    pairs.push([bestFrom[next], next]);
    for (let j = 0; j < n; j++) {
      if (!inTree[j]) {
        const d = dist2(rooms[next], rooms[j]);
        if (d < bestDist[j]) {
          bestDist[j] = d;
          bestFrom[j] = next;
        }
      }
    }
  }
  return pairs;
}
